import { styled } from 'baseui'

export const Toolbar = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '1rem',
  marginBottom: '1rem',
})

export const SearchField = styled('div', {
  width: '18rem',
})

export const PaginationRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.75rem',
  marginTop: '0.75rem',
})

export const ModalActions = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0.5rem',
  marginTop: '1rem',
})

export const ModalText = styled('p', ({ $theme }) => ({
  marginTop: 0,
  color: $theme.colors.textMuted,
}))

export const TableWrap = styled('div', {
  overflowX: 'auto',
  marginTop: '1rem',
})

export const Table = styled('table', {
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
})

export const TheadRow = styled('tr', ({ $theme }) => ({
  textAlign: 'left',
  backgroundColor: $theme.colors.bgSubtle,
}))

export const Th = styled('th', ({ $theme }) => ({
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  fontSize: '0.875rem',
  fontWeight: 400,
  color: $theme.colors.textMuted,
}))

export const ActionsTh = styled(Th, {
  textAlign: 'right',
})

export const Td = styled('td', ({ $theme }) => ({
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  borderBottomWidth: '0.0625rem',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.borderLight,
  fontSize: '0.875rem',
}))

export const ActionsTd = styled(Td, {
  textAlign: 'right',
})

export const RowActions = styled('div', {
  display: 'inline-flex',
  gap: '0.5rem',
})
